// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","slateColor":"#555555","card":"ProjectCard_card__3IlyE","active":"ProjectCard_active__13N_q"};